import { PlanningEventGroupGeneratedEntity } from "./generated/PlanningEventGroupGeneratedEntity";

export abstract class PlanningEventGroupEntity extends PlanningEventGroupGeneratedEntity {
    public get startDate(): Date | null {
        let earliest: Date | null = null;

        for (const event of this.planningEvents) {
            const start = event.startDate;
            if (!start) {
                continue;
            }

            if (earliest === null || start.getTime() < earliest.getTime()) {
                earliest = start;
            }
        }

        return earliest;
    }
    public get endDate(): Date | null {
        let latest: Date | null = null;

        for (const event of this.planningEvents) {
            const end = event.endDate ?? event.startDate;
            if (!end) {
                continue;
            }

            if (latest === null || end.getTime() > latest.getTime()) {
                latest = end;
            }
        }

        if (latest) {
            const oneDayMs = 24 * 60 * 60 * 1000;
            const earliest = this.startDate?.getTime() ?? 0;
            if (latest.getTime() - earliest < oneDayMs) {
                return new Date(latest.getTime() + oneDayMs);
            }
        }

        return latest;
    }
}
